// extracted by mini-css-extract-plugin
export default {"wrapper":"M_Rate_wrapper__av5gW","active":"M_Rate_active__4hcbZ","discount_wrapper":"M_Rate_discount_wrapper__nqUNv","discount_text":"M_Rate_discount_text__L3tOo"};